import { disableScroll, enableScroll} from '../utils/scroll';

export const showMenu = (navbarToggler, header) => {
  navbarToggler.classList.add('menu-open');
  header.classList.add('show');
  disableScroll();
}

export const hideMenu = (navbarToggler, header) => {
  navbarToggler.classList.remove('menu-open');
  header.classList.remove('show');
  enableScroll();
}

export const showSubmenu = (header) => {
  const toggler = header.querySelectorAll('.menu-item-has-children');

  toggler.forEach(item => {
    item.addEventListener('click', (e) => {
      if (!e.target.closest('.submenu')) {
        e.preventDefault();
        let submenu = e.currentTarget.querySelector('.submenu');
        submenu.classList.add('open');
      }
    })
  })
}

export const toggleMobileMenu = (navbarToggler, header) => {
  if(!navbarToggler) return;
  navbarToggler.addEventListener('click', () => (!navbarToggler.classList.contains('menu-open')) ? showMenu(navbarToggler, header) : hideMenu(navbarToggler, header));
  document.addEventListener("keyup", (e) => (e.key === 'Escape' && document.body.classList.contains('disable-scroll')) && hideMenu(navbarToggler, header));
}
